import {
  Button,
  NavBar,
  Icon,
  Toast,
  Tabs,
  WhiteSpace,
  SearchBar,
  Result,
} from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../util/axios";
const JixiaoList = styled.div`
  .month ul {
    list-style: none;
    padding: 10px 20px 10px 20px;
    margin: 0;
  }
  .month li {
    border: 1px solid #d7d7d7;
    border-radius: 5px;
    width: 100%;
    padding: 0 10px 0 10px;
    margin-bottom: 10px;
  }
  .month p {
    display: flex;
    justify-content: space-between;
  }
`;
interface Array1 {
  departmentName: string;
  staffName: string;
  reviewScore: number;
  vsheetId: string;
  uuid: string;
}
export default function Suspension() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
    rejectId?: string;
    userId?: string;
  }>({
    visible: false,
  });
  const history = useHistory();
  const tabs = [{ title: "未投票" }, { title: "已投票" }];
  const [suspensionList, setSuspensionList] = useState<Array1[]>([]);
  const [keyword, setKeyword] = useState<string>();
  const [keyword1, setKeyword1] = useState<string>();
  useEffect(() => {
    let url = window.location.href; //获取请求进来的完整url
    // console.log(url)
    // let tstr = url.substring(url.indexOf('?') + 1).split('&');//先截取url的?后面的参数部分，在根据&分割成参数数组
    let tstr = url.substring(url.indexOf("=") + 1); //获取uuid
    console.log(tstr);
    instance
      .post(
        `/oa/adjust/getTransferStaffList?vsheetId=` +
          tstr +
          "&isPromotion=" +
          "true"
      )
      .then((resp) => {
        // console.log(resp);
        console.log(resp.data.Data.data);
        if (resp.data.Status === "1") {
          setSuspensionList(resp.data.Data.data);
        }
      });
  }, []);
  return (
    <>
      <JixiaoList>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  // history.push(`/hr/rankadjustment`);
                  history.go(-1);
                }}
              />
            }
          >
            调岗或停职轮训
          </NavBar>
          <WhiteSpace />
          <Tabs tabs={tabs} initialPage={"t2"}>
            {/* 未投票 */}
            <div className="month">
              <SearchBar
                value={keyword}
                onChange={(value) => setKeyword(value)}
                placeholder="请输入搜索内容"
                className="margin"
                // onSubmit={() => {

                // }}
                // onCancel={() => {

                // }}
              />
              <ul>
                {suspensionList.map((item) => (
                  <li
                    onClick={() => {
                      window.location.href =
                        "/hr/rankadjustment/suspension/votingdetails?vsheetId=" +
                        item.vsheetId +
                        "&" +
                        encodeURI(item.uuid);
                    }}
                  >
                    <p>
                      <span>{item.departmentName}</span>
                      <span>{item.staffName}</span>
                    </p>
                  </li>
                ))}
              </ul>
            </div>
            {/* 已投票 */}
            <div className="month">
              <SearchBar
                value={keyword1}
                onChange={(value) => setKeyword1(value)}
                placeholder="请输入搜索内容"
                className="margin"
                // onSubmit={() => {

                // }}
                // onCancel={() => {

                // }}
              />
              <ul>
                <li
                  onClick={() => {
                    window.location.href =
                      "/hr/rankadjustment/suspension/votingdetails";
                  }}
                >
                  <p>
                    <span>兴业综合部</span>
                    <span>张三</span>
                  </p>
                </li>
              </ul>
            </div>
          </Tabs>
        </div>
      </JixiaoList>
    </>
  );
}
